module.exports = __webpack_public_path__ + "img/ball.3c43b0cd.svg";